import RichTextEditor from '@/admin/digital/RichTextEditor';

const inputCls = 'w-full px-3 py-2 border border-[#eae4d8] rounded-lg text-sm bg-white focus:border-[#C8A15A] focus:outline-none';
const Label = ({ children }) => <div className="text-[10px] tracking-[0.2em] uppercase text-[#888] mb-1.5">{children}</div>;

export const SECTION_OPTIONS = [
  ['business-templates', 'Business Templates'],
  ['ai-resources', 'AI Resources'],
  ['founder-insights', 'Founder Insights'],
  ['journal', 'The Journal'],
  ['digital-products', 'Digital Products'],
];
export const ARTICLE_SECTIONS = ['founder-insights', 'journal'];

export const SectionPicker = ({ form, setForm }) => {
  const isArticle = form.content_type === 'article';
  const toggle = (k) => setForm((f) => {
    const has = f.sections.includes(k);
    return { ...f, sections: has ? f.sections.filter((x) => x !== k) : [...f.sections, k] };
  });
  const setType = (t) => setForm((f) => ({
    ...f, content_type: t,
    sections: t === 'article' ? (f.sections.filter((s) => ARTICLE_SECTIONS.includes(s)).length ? f.sections.filter((s) => ARTICLE_SECTIONS.includes(s)) : ['journal']) : f.sections,
  }));
  return (
    <div className="space-y-4">
      <div>
        <Label>Content type</Label>
        <div className="flex gap-2">
          {[['download', 'Download'], ['article', 'Article']].map(([k, l]) => (
            <button key={k} type="button" onClick={() => setType(k)} data-testid={`dp-editor-type-${k}`}
              className={`text-xs tracking-[0.14em] uppercase px-5 py-2 rounded-full border ${form.content_type === k ? 'bg-[#111] text-white border-[#111]' : 'bg-white border-[#eae4d8] text-[#555]'}`}>{l}</button>
          ))}
        </div>
        <p className="text-xs text-[#888] mt-2">{isArticle ? 'Written content published on the site. Available in Founder Insights and The Journal.' : 'A file visitors claim or purchase, then download securely.'}</p>
      </div>
      <div>
        <Label>Sections (choose one or more)</Label>
        <div className="flex flex-wrap gap-2" data-testid="dp-editor-sections">
          {SECTION_OPTIONS.map(([k, l]) => {
            const disabled = isArticle && !ARTICLE_SECTIONS.includes(k);
            const on = form.sections.includes(k);
            return (
              <button key={k} type="button" disabled={disabled} onClick={() => toggle(k)} data-testid={`dp-editor-section-${k}`}
                className={`text-xs px-4 py-2 rounded-full border transition-colors ${on ? 'bg-[#C8A15A] border-[#C8A15A] text-[#111]' : 'bg-white border-[#eae4d8] text-[#555]'} ${disabled ? 'opacity-30 cursor-not-allowed' : ''}`}>
                {on ? '✓ ' : ''}{l}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const CtaFields = ({ label, value, onChange, testid }) => (
  <div className="grid sm:grid-cols-2 gap-2">
    <input placeholder={`${label} label`} value={value?.label || ''} onChange={(e) => onChange({ ...(value || {}), label: e.target.value })} className={inputCls} data-testid={`${testid}-label`} />
    <input placeholder="Link (/page or https://…)" value={value?.url || ''} onChange={(e) => onChange({ ...(value || {}), url: e.target.value })} className={inputCls} data-testid={`${testid}-url`} />
  </div>
);

export const ArticleFields = ({ form, setForm }) => {
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  return (
    <div className="space-y-6" data-testid="dp-editor-article-fields">
      <div className="grid sm:grid-cols-3 gap-4">
        <div><Label>Publication date</Label><input type="date" value={form.published_date || ''} onChange={(e) => set('published_date')(e.target.value)} className={inputCls} data-testid="dp-editor-published-date" /></div>
        <div><Label>Read time (auto if blank)</Label><input value={form.read_time} onChange={(e) => set('read_time')(e.target.value)} placeholder="5 min read" className={inputCls} data-testid="dp-editor-read-time" /></div>
        <div><Label>Eyebrow label</Label><input value={form.kicker} onChange={(e) => set('kicker')(e.target.value)} placeholder="From My Desk" className={inputCls} data-testid="dp-editor-kicker" /></div>
      </div>
      <div><Label>Article body</Label><RichTextEditor value={form.body_html} onChange={set('body_html')} /></div>
      <label className="flex items-start gap-3 text-sm text-[#555] cursor-pointer">
        <input type="checkbox" checked={!!form.unlisted} onChange={(e) => set('unlisted')(e.target.checked)} className="mt-1 accent-[#C8A15A]" data-testid="dp-editor-unlisted" />
        <span><strong className="text-[#111]">Hidden from listings.</strong> Keeps the article out of the Journal, homepage, section pages, and sitemap. It stays reachable only by its direct link and is marked noindex.</span>
      </label>
      <div className="space-y-2">
        <Label>Optional buttons at the end of the article</Label>
        <CtaFields label="Primary button" value={form.primary_cta} onChange={set('primary_cta')} testid="dp-editor-cta-primary" />
        <CtaFields label="Secondary button" value={form.secondary_cta} onChange={set('secondary_cta')} testid="dp-editor-cta-secondary" />
      </div>
    </div>
  );
};
